module.exports = __webpack_public_path__ + "static/media/zhibohot.f7ea56b5.png";